<section class="block p-2 bg-gray-light">
  <h4 class="font-weight-light fs-40 title">
    <span *scText="rendering.fields.title"></span>
  </h4>
  <div class="subtitle" *scRichText="rendering.fields.description"></div>
  <div
    class="fs-26 font-weight-bold mt-6 mb-3"
    *scText="items.tableTitle.fields.label"
  ></div>
  <div class="table-responsive">
    <table class="table table-separate">
      <colgroup>
        <col class="w-sm-50" />
        <col class="w-sm-16" />
        <col class="w-sm-16" />
        <col class="w-sm-16" />
      </colgroup>
      <thead class="bg-gray-light">
        <tr>
          <th class="border-top-0" *ngFor="let item of tableColumns">
            <span *scText="item.fields.label"></span>
          </th>
          <th class="border-top-0"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          [ngClass]="{ 'table-row-odd': setOdd(i) }"
          *ngFor="let card of cards; let i = index"
        >
          <td class="text-marine-blue">{{ card | creditCardName }}</td>
          <td>
            {{ card.limit.amount | number }} {{ card.limit.currencyCode }}
          </td>
          <td>
            {{ card.status }}
          </td>
          <td class="pt-1 pb-1 align-items-center d-flex justify-content-end">
            <ng-container *ngIf="card.pendingLimitRequest">
              <span
                class="card-pending"
                *scText="items.pending.fields.label"
              ></span>
            </ng-container>
            <button class="btn btn-icon btn-white p--6">
              <i class="icon-selection fs-24"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!isLoading && cards.length < 1">
          <td class="text-center" colspan="4">
            <span
              class="badge badge-warning"
              *scText="rendering.fields.noMoreLabel"
            ></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="loader-bar" [hidden]="!isLoading"></div>
</section>
